import React from 'react'

import { Field } from 'formik'

import { Button, Form, Col } from '_zari/core'

import { MonedasConstant } from 'constants/index'

import { TipoCambioModal } from 'sharedComponents/modals'

import { KeyEventUtil } from 'utils'

import * as TiposCambioService from 'services/tiposCambio.service'

const TipoCambioFormGroup = ({ iError, iTouched, iFechaDocumento, setFieldValue }) => {
  const [mostrarModal, setMostrarModal] = React.useState(false)

  const consultarTipoCambio = React.useCallback(() => {
    TiposCambioService.getxFechaxMonedaxTipoCambio(
      iFechaDocumento,
      MonedasConstant.DOLARES,
      'VENT'
    ).then(({ data }) => {
      setFieldValue('tipoCambio', data.tipoCambio || 0)
    })
  }, [iFechaDocumento, setFieldValue])

  React.useEffect(() => {
    if (iFechaDocumento !== '') {
      consultarTipoCambio()
    }
  }, [iFechaDocumento, setFieldValue, consultarTipoCambio])

  const clickTiposCambio = React.useCallback(() => {
    setMostrarModal(true)
  }, [])

  const handleCloseModal = React.useCallback(() => {
    setMostrarModal(false)
    consultarTipoCambio()
  }, [consultarTipoCambio])

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-tipoDocumento', e)
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='T/C' htmlFor='input-tipoCambio' md={4} alignRightAt='md' />
        <Col md={8}>
          <Form.InputGroup>
            <Field name='tipoCambio'>
              {({ field }) => (
                <Form.InputNumber
                  {...field}
                  id='input-tipoCambio'
                  isInvalid={iTouched && iError}
                  onKeyDown={onKeyDown}
                />
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={clickTiposCambio}>O</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarModal && <TipoCambioModal show={mostrarModal} handleClose={handleCloseModal} />}
    </>
  )
}

export default React.memo(TipoCambioFormGroup)
